module.exports = __webpack_public_path__ + "media/src/website/images/locations/rimsting/rimsting_small_02-3deb42b3296b325a31c0490b9ea9130c.jpg";